// extracted by mini-css-extract-plugin
export default {"baekjoonInputWrapper":"baekjoonAddFormElement_baekjoonInputWrapper__i9rL4"};